<template>
  <Icon>
    <svg
      slot="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 719.76 129.02">
      <defs/>
      <g
        id="Warstwa_2"
        data-name="Warstwa 2">
        <g
          id="Warstwa_1-2"
          data-name="Warstwa 1">
          <circle
            class="cls-1"
            cx="5.95"
            cy="75.49"
            r="5.95
          "/>
          <circle
            class="cls-1"
            cx="5.95"
            cy="98.29"
            r="5.95"
          />
          <circle
            class="cls-1"
            cx="28.72"
            cy="52.69"
            r="6.24"
          />
          <circle
            class="cls-2"
            cx="28.72"
            cy="75.49"
            r="6.24"
          />
          <circle
            class="cls-2"
            cx="28.72"
            cy="98.29"
            r="6.24"
          />
          <circle
            class="cls-1"
            cx="28.72"
            cy="121.09"
            r="6.52"
          />
          <circle
            class="cls-1"
            cx="51.5"
            cy="29.89"
            r="6.52"
          />
          <circle
            class="cls-2"
            cx="51.5"
            cy="52.69"
            r="6.52"
          />
          <circle
            class="cls-2"
            cx="51.5"
            cy="121.09"
            r="6.8"
          />
          <circle
            class="cls-1"
            cx="74.27"
            cy="7.09"
            r="6.8"
          />
          <circle
            class="cls-2"
            cx="74.27"
            cy="29.89"
            r="6.8"
          />
          <circle
            class="cls-3"
            cx="74.27"
            cy="121.09"
            r="7.09"
          />
          <circle
            class="cls-2"
            cx="97.04"
            cy="7.09"
            r="7.09"
          />
          <circle
            class="cls-3"
            cx="97.04"
            cy="121.09"
            r="7.37"
          />
          <circle
            class="cls-3"
            cx="119.81"
            cy="14.69"
            r="7.37"
          />
          <circle
            class="cls-4"
            cx="120.81"
            cy="121.09"
            r="7.65"
          />
          <circle
            class="cls-4"
            cx="145.09"
            cy="121.09"
            r="7.94"
          />
          <circle
            class="cls-4"
            cx="171.47"
            cy="56.62"
            r="8.22"
          />
          <circle
            class="cls-4"
            cx="167.87"
            cy="113.49"
            r="8.22"
          />
          <circle
            class="cls-4"
            cx="185.49"
            cy="75.49"
            r="8.5"
          />
          <circle
            class="cls-4"
            cx="148.21"
            cy="50.65"
            r="7.94"
          />
          <circle
            class="cls-3"
            cx="130.81"
            cy="34.75"
            r="7.65"
          />
          <circle
            class="cls-4"
            cx="185.49"
            cy="98.29"
            r="8.5"
          />
          <path
            class="cls-5"
            d="M232.37,86.38V42.56a7.68,7.68,0,0,1,7.68-7.68H255.7c18.55,0,31.41,11.8,31.41,29.63S274.25,94.06,255.7,94.06H240.05A7.68,7.68,0,0,1,232.37,86.38Zm41.88-21.87C274.25,54,267.86,46,255.7,46H245V83H255.7C267.41,83,274.25,74.54,274.25,64.51Z"/>
          <path
            class="cls-5"
            d="M333.86,94.06l-3.64-10H304.85l-3.73,10H286.75l22.89-59.18h15.79l22.8,59.18ZM317.54,47.48l-9.23,25.46h18.45Z"/>
          <path
            class="cls-5"
            d="M360.71,94.06V46h-17.3V34.88h47.2V46H373.4V94.06Z"/>
          <path
            class="cls-5"
            d="M432.82,94.06l-3.64-10H403.8l-3.72,10H385.71L408.6,34.88h15.79l22.8,59.18ZM416.49,47.48l-9.22,25.46h18.45Z"/>
          <path
            class="cls-5"
            d="M450.07,85.72l6.83-9.59a26,26,0,0,0,18.81,8c6.92,0,10.29-3.19,10.29-6.57,0-10.47-34.07-3.28-34.07-25.55,0-9.85,8.52-18,22.45-18,9.41,0,17.21,2.84,23.07,8.25l-7,9.23A25.4,25.4,0,0,0,473.23,45c-5.41,0-8.43,2.4-8.43,5.95,0,9.4,34,3.1,34,25.19,0,10.83-7.72,19-23.69,19C463.73,95.12,455.57,91.31,450.07,85.72Z"/>
          <path
            class="cls-5"
            d="M507.29,94.06V34.88H535c12.87,0,19.88,8.69,19.88,19.07S547.75,73,535,73H519.89v21ZM542,54c0-5-3.72-8-8.69-8h-13.4v16h13.4C538.26,61.94,542,58.83,542,54Z"/>
          <path
            class="cls-5"
            d="M596.9,94.06l-3.64-10H567.88l-3.72,10H549.79l22.89-59.18h15.79l22.8,59.18ZM580.57,47.48l-9.23,25.46H589.8Z"/>
          <path
            class="cls-5"
            d="M610.91,64.51c0-18.19,13.75-30.61,31.49-30.61,13.05,0,20.59,7.1,24.76,14.46l-10.83,5.33a16,16,0,0,0-13.93-8.61c-10.73,0-18.54,8.25-18.54,19.43s7.81,19.43,18.54,19.43a15.85,15.85,0,0,0,13.93-8.6l10.83,5.23c-4.26,7.36-11.71,14.55-24.76,14.55C624.66,95.12,610.91,82.7,610.91,64.51Z"/>
          <path
            class="cls-5"
            d="M674.69,94.06V34.88H712a7.72,7.72,0,0,1,7.72,7.72V46H687.29V58.48h31.85V69.57H687.29V83h32.47v3.4a7.69,7.69,0,0,1-7.69,7.69Z"/>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsLogoIcon",
  components: {
    Icon
  },
  extends: Icon
};
</script>
<style lang="scss" scoped>
.cls-1 {
  fill: #f6921e;
}
.cls-2 {
  fill: #3fbc92;
}
.cls-3 {
  fill: #1c99ef;
}
.cls-4 {
  fill: #286289;
}
.cls-5 {
  fill: #003b4f;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-logo-icon.vue